<app-header-page>
    <app-component-documents-search></app-component-documents-search>
</app-header-page>

<h1 *ngIf="tableType === 'all'">{{ 'HEADERS.DOCS' | translate }}</h1>
<h1 *ngIf="tableType === 'inbox'">{{ 'HEADERS.INBOX' | translate }}</h1>
<h1 *ngIf="tableType === 'approve'">{{ 'HEADERS.VISOR' | translate }}</h1>
<h1 *ngIf="tableType === 'signed'">{{ 'HEADERS.SIGNED' | translate }}</h1>
<h1 *ngIf="tableType === 'registry'">{{ 'HEADERS.REGISTRY' | translate }}</h1>

<div *ngIf="showTabs && response.right.is_edit_settings">
    <div class="super__tabs">
        <div (click)="tab = 'view'; controller.loadNav(pagination)" [class.active]="tab === 'view'"
             [class.disabled_tab]="isPermissionsChanged"
             class="super__tabs tab"
             data-action="view">
            <span>{{ 'DOCUMENTS.TEXT.VIEW' | translate }}</span>
        </div>
        <div (click)="tab = 'edit'" [class.active]="tab === 'edit'"
             [class.disabled_tab]="isPermissionsChanged"
             class="super__tabs tab"
             data-action="edit">
            <span>{{ 'DOCUMENTS.TEXT.SETTINGS' | translate }}</span>
        </div>
        <div (click)="tab = 'access'" [class.active]="tab === 'access'"
             class="super__tabs tab"
             data-action="access">
            <span>{{ 'DOCUMENTS.TEXT.ACCESS' | translate }}</span>
        </div>
    </div>

    <div class="tab__content">
        <ng-container *ngIf="tab === 'edit'">
            <ng-container *ngTemplateOutlet="editDocs">
            </ng-container>
        </ng-container>
        <ng-container *ngIf="tab === 'access'">
            <app-documents-access-settings
                    (changeEditEvent)="isPermissionsChanged = $event"
                    [target]="response.folder"
            ></app-documents-access-settings>
        </ng-container>
    </div>
</div>

<ng-template #editDocs>
    <h2>{{ 'DOCUMENTS.TEXT.EDIT_FOLDER' | translate }} {{ response.folder.name }}</h2>

    <div>
        <h3>{{ 'MODALS.FIELDS.TITLE' | translate }}:</h3>
        <input #name [value]="response.folder.name" class="w-25 form-control"
               placeholder="{{ 'MODALS.FIELDS.TITLE' | translate }}"
               type="text">

        <h3>{{ 'MODALS.FIELDS.DESCRIPTION' | translate }}:</h3>
        <input #description
               [placeholder]="response.folder.description ? response.folder.description : ('MODALS.FIELDS.SELECT.EMPTY' | translate)"
               [value]="response.folder.description"
               class="w-25 form-control" type="text">
    </div>

    <button (click)="onEditFolder(name.value, description.value);"
            class="btn btn-success mt-2"
            data-action="editFolder"
    >
        <span>{{ 'BUTTON_TEXT.ACCEPT' | translate }}</span>
    </button>
</ng-template>

<div *ngIf="tab === 'view'">
    <app-component-button-create-fcfv
            *ngIf="tableType === 'all'"
            [isCreateCollection]="isCreateCollection && response.right.is_upload_file"
            [isCreateFolder]="isCreateFolder && response.right.is_create_folder"
    ></app-component-button-create-fcfv>

    <app-component-folder-and-file-table
            (eventClick)="onEventTrClick($event)"
            (eventFind)="onEventFind($event)"
            [$mediator]="controller.$mediator"
            [preparedPagination]="pagination"
    ></app-component-folder-and-file-table>
</div>
